import * as React from 'react';

import ErrorBoundary from '@components/ErrorBoundary';
import { Flex } from '@components/Flex';
import { WishlistProductDetailIcon } from '@components/Universals/WishlistModifier/WishlistProductDetailIcon';
import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';
import { useTrackingContext } from '@context/tracking/TrackingContext';

import { IHeaderProps } from './model';
import { ProductRating } from './ProductRating';
import {
  StyledHeader,
  H1,
  Span,
  Description,
  SubName,
  BrandExtraLine,
  ProductNameWrapper,
} from './styled';
import { trackBrandClick, withSpaceAfterWord } from './utils';

export const Header = ({
  desc,
  subName,
  brandInfo,
  variantName,
  catalogId,
  children,
  reviewsId,
  hideReviews = false,
  visualsOnly = false,
}: React.PropsWithChildren<IHeaderProps>) => {
  const { getTimeFromInit } = useTrackingContext();
  const { experiment_pd_wishlist_button_placement } = useFeatureFlags();

  const handleTrackClick = () =>
    trackBrandClick({
      timing: getTimeFromInit(),
      name: brandInfo?.name ?? '',
    });

  return (
    <ErrorBoundary>
      <StyledHeader id={visualsOnly ? undefined : 'pdHeader'}>
        <H1
          data-testid={visualsOnly ? undefined : 'pd-header-title'}
          as={visualsOnly ? 'div' : 'h1'}
        >
          <Flex justify="space-between" gap="8px">
            <ProductNameWrapper>
              {brandInfo && (
                <BrandExtraLine
                  onClick={handleTrackClick}
                  href={brandInfo.url ?? undefined}
                >
                  {brandInfo.name}
                </BrandExtraLine>
              )}

              <Span>{withSpaceAfterWord(variantName)}</Span>
            </ProductNameWrapper>

            {experiment_pd_wishlist_button_placement && (
              <WishlistProductDetailIcon />
            )}
          </Flex>

          {subName && <SubName>{withSpaceAfterWord(subName)}</SubName>}

          <Description>{desc}</Description>
        </H1>

        {!hideReviews && (
          <ProductRating reviewsId={reviewsId} catalogMasterId={catalogId} />
        )}

        {children}
      </StyledHeader>
    </ErrorBoundary>
  );
};
